import { render, staticRenderFns } from "./GiftSociallSkillsCategory.vue?vue&type=template&id=91d2af78&scoped=true&"
import script from "./GiftSociallSkillsCategory.vue?vue&type=script&lang=js&"
export * from "./GiftSociallSkillsCategory.vue?vue&type=script&lang=js&"
import style0 from "./GiftSociallSkillsCategory.vue?vue&type=style&index=0&id=91d2af78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d2af78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable,VDialog,VLayout,VTextField})
